module.exports = __webpack_public_path__ + "img/icon-384x384.912ebeee.png";